import moment from 'moment/moment';

import { SettlementStatus } from '../../types';

export const FILTER_DATE_OPTIONS = [
  {
    id: 'today',
    label: 'Today',
  },
  {
    id: 'thisWeek',
    label: 'This Week',
  },
  {
    id: 'lastWeek',
    label: 'Last Week',
  },
  {
    id: 'thisMonth',
    label: 'This Month',
  },
  {
    id: 'lastMonth',
    label: 'Last Month',
  },
  {
    id: 'earlier',
    label: 'Earlier',
  },
];

export const DATE_FILTER_VALUES = {
  today: {
    from: moment().startOf('day').format(),
    to: moment().endOf('day').format(),
  },
  thisWeek: {
    from: moment().startOf('week').format(),
    to: moment().endOf('week').format(),
  },
  lastWeek: {
    from: moment().subtract(1, 'week').startOf('week').format(),
    to: moment().subtract(1, 'week').endOf('week').format(),
  },
  thisMonth: {
    from: moment().startOf('month').format(),
    to: moment().endOf('month').format(),
  },
  lastMonth: {
    from: moment().subtract(1, 'month').startOf('month').format(),
    to: moment().subtract(1, 'month').endOf('month').format(),
  },
  earlier: {
    from: moment(0).format(),
    to: moment().subtract(1, 'month').startOf('month').format(),
  },
};

export const DEDUCTION_TYPE_OPTIONS = [
  {
    id: 'Expense Reimbursement',
    label: 'Expense Reimbursement',
  },
  {
    id: 'Lien',
    label: 'Lien',
  },
  {
    id: 'Service Provider',
    label: 'Service Provider',
  }
];

export const CASES_STATUS_FILTER_OPTIONS = [
  {
    id: 'Draft',
    label: 'Draft',
  },
  {
    id: 'Active',
    label: 'Active',
  },
  {
    id: 'Closed',
    label: 'Closed',
  },
  {
    id: 'Abandoned',
    label: 'Abandoned',
  },
  // {
  //   id: 'Archived',
  //   label: 'Archived',
  // },
];

export const TRANSACTION_TYPE_FILTER_OPTIONS = [
  {
    id: 'All Types',
    label: 'All Types',
  },
  {
    id: 'CREDIT',
    label: 'CREDIT',
  },
  {
    id: 'DEBIT',
    label: 'DEBIT',
  },
];

export const VENDOR_TYPE_FILTER_OPTIONS = [
  {
    id: 'All Vendor Types',
    label: 'All Vendor Types',
  },
  {
    id: 'LIEN_HOLDER',
    label: 'Lien Holder',
  },
  {
    id: 'SERVICE_PROVIDER',
    label: 'Service Provider',
  },
  {
    id: 'SECONDARY_FIRM',
    label: 'Secondary Firm',
  }

];

export const METHOD_TYPE_FILTER_OPTIONS = [
  {
    id: 'All Methods',
    label: 'All Methods',
  },
  {
    id: 'ACH',
    label: 'ACH',
  },
  {
    id: 'CHECK',
    label: 'Check',
  },
];

export const VERIFICATION_STATUS_FILTER_OPTIONS = [
  {
    id: 'All Statuses',
    label: 'All Statuses',
  },
  {
    id: 'Verified',
    label: 'Verified',
  },
  {
    id: 'Pending',
    label: 'Pending',
  },
];

export const ACCOUNT_STATUS_FILTER_OPTIONS = [
  {
    id: 'All Statuses',
    label: 'All Statuses',
  },
  {
    id: 'NEW',
    label: 'New',
  },
  {
    id: 'CONFIRMATION_REQUIRED_VENDOR',
    label: 'Vendor Confirmation Required',
  },
  {
    id: 'CONFIRMATION_REQUIRED_ADMIN',
    label: 'Admin Confirmation Required',
  },
  {
    id: 'ACCOUNT_NUMBER_VALIDATION',
    label: 'Account Number Validation',
  },
  {
    id: 'PROVISIONING',
    label: 'Provisioning',
  },
  {
    id: 'FAILED',
    label: 'Failed',
  },
  {
    id: 'ACTIVE',
    label: 'Active',
  },
  {
    id: 'ARCHIVED',
    label: 'Archived',
  },
];

export const DEDUCTIONS_STATUS_FILTER_OPTIONS = [
  {
    id: 'Paid',
    label: 'Paid',
  },
  {
    id: 'Unpaid',
    label: 'Unpaid',
  },
  {
    id: 'PaymentInProgress',
    label: 'Payment In Progress',
  },
  {
    id: 'Error',
    label: 'Error',
  },
  {
    id: 'CriticalError',
    label: 'Critical Error',
  },
];

export const MAPPED_DEDUCTIONS_STATUS_FILTER_OPTIONS = [
  {
    id: 'Paid',
    label: 'Paid',
  },
  {
    id: 'Funding',
    label: 'Funding',
  },
  {
    id: 'InDistribution',
    label: 'In Distribution',
  },
  {
    id: 'Failed',
    label: 'Failed',
  },
  {
    id: 'NotStarted',
    label: 'Not Started',
  },
  {
    id: 'Withhold',
    label: 'Withhold',
  },
];

export const ONBOARDING_STATUS_FILTER_OPTIONS = [
  {
    id: 'All Statuses',
    label: 'All Statuses',
  },
  {
    id: 'COMPLETED',
    label: 'Completed',
  },
  {
    id: 'IN_PROGRESS',
    label: 'In Progress',
  },
  {
    id: 'BLOCKED',
    label: 'Blocked',
  },
  {
    id: 'INVITE_SENT',
    label: 'Invite Sent',
  },
  {
    id: 'NOT_STARTED',
    label: 'Not Started',
  },
  // {
  //   id: 'NOT_APPLICABLE',
  //   label: 'Not Applicable',
  // },
];

export const SETTLEMENT_TYPE_FILTER_OPTIONS = [
  {
    id: 'All Types',
    label: 'All Types',
  },
  {
    id: 'STANDARD',
    label: 'Settlement',
  },
  {
    id: 'STANDARD_PIP',
    label: 'Settlement + PIP',
  },
  {
    id: 'LIEN_REPAYMENT',
    label: 'Settlement + Lien Reimbursement'
  }  
];

export const DATA_REQUESTS_STATUS_FILTER_OPTIONS = [
  {
    id: 'Draft',
    label: 'Draft',
  },
  {
    id: 'Unopened',
    label: 'Unopened',
  },
  {
    id: 'Opened',
    label: 'Opened',
  },
  {
    id: 'Completed',
    label: 'Completed',
  },
  {
    id: 'Canceled',
    label: 'Canceled',
  },
  {
    id: 'Rejected',
    label: 'Rejected',
  },
  // {
  //   id: 'Archived',
  //   label: 'Archived',
  // },
];

export const DOCUMENT_REQUESTS_STATUS_FILTER_OPTIONS = [
  {
    id: 'Draft',
    label: 'Draft',
  },
  {
    id: 'Unopened',
    label: 'Unopened',
  },
  {
    id: 'Opened',
    label: 'Opened',
  },
  {
    id: 'Completed',
    label: 'Completed',
  },
  {
    id: 'Rejected',
    label: 'Rejected',
  },
  {
    id: 'Canceled',
    label: 'Canceled',
  },
  // {
  //   id: 'Archived',
  //   label: 'Archived',
  // },
];

export const SIGNATURE_REQUESTS_STATUS_FILTER_OPTIONS = [
  {
    id: 'Opened',
    label: 'Opened',
  },
  {
    id: 'Completed',
    label: 'Completed',
  },
  {
    id: 'Rejected',
    label: 'Rejected',
  },
  {
    id: 'CancelInProgress',
    label: 'Cancel In Progress',
  },
  {
    id: 'Canceled',
    label: 'Canceled',
  },
  {
    id: 'Unopened',
    label: 'Unopened',
  },
  // {
  //   id: 'Archived',
  //   label: 'Archived',
  // },
];

export const USERS_STATUS_FILTER_OPTIONS = [
  {
    id: 'Active',
    label: 'Active',
  },
  {
    id: 'Inactive',
    label: 'Inactive',
  },
];

export const CLIENTS_STATUS_FILTER_OPTIONS = [
  {
    id: 'Created',
    label: 'Created',
  },
  {
    id: 'Active',
    label: 'Active',
  },
  {
    id: 'Deactivated',
    label: 'Deactivated',
  },
  // {
  //   id: 'Archived',
  //   label: 'Archived',
  // },
];

export const SETTLEMENTS_STATUS_FILTER_OPTIONS: Array<{
  id: SettlementStatus;
  label: string;
}> = [
    {
      id: SettlementStatus.Draft,
      label: 'Draft',
    },
    {
      id: SettlementStatus.Funding,
      label: 'Funding',
    },
    {
      id: SettlementStatus.Paid,
      label: 'Paid',
    },
    {
      id: SettlementStatus.Failed,
      label: 'Failed',
    },
    {
      id: SettlementStatus.InDistribution,
      label: 'In Distribution'
    },
    {
      id: SettlementStatus.NotStarted,
      label: 'Not Started'
    }
  ];

export const APPROVAL_STATUS_FILTER_OPTIONS = [
  {
    id: 'All Statuses',
    label: 'All Statuses',
  },
  {
    id: 'AWAITING_APPROVAL',
    label: 'Awaiting Review',
  },
  {
    id: 'APPROVED_PROCESSING',
    label: 'Payment in Process',
  },
  {
    id: 'APPROVED_TO_BE_PAID',
    label: 'Ready to Pay',
  },
  {
    id: 'CHANGES_REQUESTED',
    label: 'Changes Requested',
  },
  {
    id: 'WAITING_FOR_SUBMISSION',
    label: 'Waiting for Submission',
  },
  {
    id: 'COMPLETED',
    label: 'Payment Completed',
  },
  {
    id: 'NOT_AVAILABLE',
    label: 'Not Available',
  }
];

export const DATA_FILE_STATUS_FILTER_OPTIONS = [
  {
    id: 'Processing',
    label: 'Processing',
  },
  {
    id: 'Error',
    label: 'Error',
  },
  {
    id: 'Queued',
    label: 'Queued',
  },
  {
    id: 'Completed',
    label: 'Completed',
  },
];

export const DATA_FILE_TYPE_FILTER_OPTIONS = [
  {
    id: 'Cases File',
    label: 'CasesFile',
  },
];

export const ACCOUNT_TYPE_FILTER_OPTIONS = [
  {
    id: 'All Accounts',
    label: 'All Accounts',
  },
  {
    id: 'Revenue Recognition',
    label: 'Revenue Recognition',
  },
  {
    id: 'Expense Reimbursement',
    label: 'Expense Reimbursement',
  },
  {
    id: 'Case Account',
    label: 'Case Account',
  },
];

export const ALL_SETTLEMENTS_FILTER_VALUE = 'All Settlements';
